import type { UserResume } from '../types/models/user-resume.js';
import type { User } from '../types/models/user.js';
import { ONGOING_PROGRAM_STATUSES } from '../constants/program-states.js';

export const canShareProfile = (resumes: UserResume[] | undefined | null): boolean =>
  (resumes ?? []).some((resume) => !!resume.featuredAt);

/**
 * Whether the user is eligible to feature a CV. Both conditions must hold:
 * the user has an ongoing program (IN_PROGRESS or EXTENDED) AND that program
 * is linked to V1 (both addviseoUserId and addviseoProgramId set) — featuring
 * is only meaningful when the profile can be pushed to V1 partners.
 */
export const canFeatureResume = (user: Pick<User, 'userPrograms'> | null | undefined): boolean => {
  if (!user) return false;
  return (user.userPrograms ?? []).some(
    (program) =>
      ONGOING_PROGRAM_STATUSES.includes(program.status) &&
      program.addviseoUserId != null &&
      program.addviseoProgramId != null,
  );
};
